var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9879 1.70101C16.2565 1.70101 15.6641 2.30821 15.6641 3.05515C15.6641 3.54105 15.914 3.96406 16.2903 4.20444C15.4952 5.32784 14.3734 6.63244 13.217 7.01037C11.6953 7.50809 10.2765 4.44924 9.57806 2.63138C10.0958 2.44796 10.4729 1.94728 10.4729 1.35342C10.4729 0.606478 9.88129 0 9.15228 0C8.4248 0 7.83246 0.606443 7.83246 1.35342C7.83246 1.94728 8.20875 2.44724 8.72726 2.63138C8.03044 4.44924 6.6132 7.50809 5.08915 7.01037C3.93431 6.63244 2.81011 5.32784 2.01667 4.20444C2.39139 3.9641 2.642 3.5418 2.642 3.05515C2.642 2.30821 2.04886 1.70101 1.31981 1.70101C0.592331 1.70101 0 2.30821 0 3.05515C0 3.80433 0.592331 4.41077 1.31981 4.41077C1.33475 4.41077 1.34494 4.40707 1.35911 4.40559L3.14244 12.2043H15.1645L16.9486 4.40559C16.9612 4.40635 16.9737 4.41077 16.9887 4.41077C17.7154 4.41077 18.3077 3.80433 18.3077 3.05515C18.3069 2.30821 17.7146 1.70101 16.9879 1.70101Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1034 12.4785H3.20312V13.9998H15.1034V12.4785Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.7e0e82dff91a2777279b8fe8ccedfa9d.svg";
export { ForwardRef as ReactComponent };